import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { CTA } from "../components/CTA";
import { EQUIPMENT_GRID } from "../data/content";

export default function Equipment() {
  return (
    <div data-testid="equipment-page">
      <Seo
        title="Electrical Equipment We Buy | Circuit Breakers, Switchgear, Transformers, Wire"
        description="Velocity Electrical Surplus buys circuit breakers, bus plugs, disconnects, switchgear, transformers, motor control centers, panelboards and electrical wire nationwide."
      />
      <section className="border-b border-white/10 bg-ves-charcoal/40">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
          <p className="font-heading text-xs font-bold tracking-[0.25em] text-ves-green">
            WE BUY — NATIONWIDE
          </p>
          <h1 className="mt-3 font-heading text-4xl font-black text-white sm:text-5xl">
            ELECTRICAL EQUIPMENT WE BUY
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-white/75 sm:text-lg">
            We purchase new, used, obsolete, and surplus industrial electrical equipment —
            from individual pallets to complete warehouses of electrical inventory. Select a
            category below to sell your equipment.
          </p>
        </div>
      </section>

      <section className="bg-ves-black py-16 sm:py-20">
        <div className="mx-auto grid max-w-7xl gap-6 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3 lg:px-8">
          {EQUIPMENT_GRID.map((card, i) => (
            <div
              key={card.title}
              className="group flex flex-col border border-white/10 bg-ves-charcoal/50 transition-all duration-150 hover:-translate-y-1 hover:border-ves-green/60"
              data-testid={`equipment-page-card-${i}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ves-black/70 to-transparent" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h2 className="font-heading text-xl font-black text-white">{card.title}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-white/65">{card.desc}</p>
                <div className="mt-5 flex items-center gap-4">
                  <Link
                    to={`/sell-your-surplus?category=${encodeURIComponent(card.category)}`}
                    className="bg-ves-green px-4 py-2.5 font-heading text-xs font-black tracking-wide text-ves-black transition-colors duration-150 hover:bg-white"
                    data-testid={`equipment-page-sell-btn-${i}`}
                  >
                    SELL THIS EQUIPMENT
                  </Link>
                  {card.link && (
                    <Link
                      to={card.link}
                      className="flex items-center gap-1 text-xs font-bold text-white/60 transition-colors duration-150 hover:text-ves-green"
                      data-testid={`equipment-page-details-${i}`}
                    >
                      Details <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTA />
    </div>
  );
}
